import React, { useContext } from "react"
import { Context } from "../../../context/app-context"
import BtnGeneric from "../../atoms/btn-generic/btn-generic"
import AnchorsLinks from "../../molecules/anchors-links/anchors-links"
import ImageLibreta from "../../../assets/images/learn/imageLibreta.png"
import "./learn-products.scss"

export default function Ambassador() {
  const { dispatch } = useContext(Context)

  const handleToInscription = () => {
    dispatch({
      type: "set-context",
      payload: {
        modalActive: {
          type: "login",
          props: { colorBlur: "pink" },
        },
      },
    })
  }
  return (
    <div className="f-aprende-learn f-embajadoras-decorations">
      <div className="f-aprende-learn__container ">
        <AnchorsLinks
          anchors={[
            {
              label: "Jabón Agua de rosas",
              ref: "/magazin/concursos/embajadoras/aprende/#jabon-agua-de-rosas",
            },
            {
              label: "Jabón Sensiti-V",
              ref: "/magazin/concursos/embajadoras/aprende/#jabon-sensiti-v",
            },
            {
              label: "Jabón Fórmula Herbal",
              ref: "/magazin/concursos/embajadoras/aprende/#jabon-formula-herbal",
            },
            {
              label: "Jabón Frescura Extrema",
              ref: "/magazin/concursos/embajadoras/aprende/#jabon-frescura-extrema",
            },
          ]}
        />

        <div className="f-aprende-learn__content--pink f-aprende-learn__content--pink-small">
          <p className="f-aprende-learn__text white">
            Aprende todo sobre{" "}
            <b className="f-aprende-learn__text--bold">
              Jabones íntimos Nosotras que protagonizarán este Embajadoras 2021.
            </b>
          </p>
        </div>

        <div className="f-aprende-learn__first-section">
          <div className="f-aprende-learn__first-section--ancla" id="jabon-agua-de-rosas" />
          <div className="f-aprende-learn__first-section--left">
            <div className="f-aprende-learn__first-title"></div>
            <div className="f-aprende-learn__first-image mobile decorator"></div>
            <div className="f-aprende-learn__list-container margin decorator-desktop">
              <div className="f-aprende-learn__text ">
                <p>
                  <b className="f-aprende-learn__text--bold">
                    Usa Jabón Íntimo Nosotras Agua de Rosas
                  </b>{" "}
                  todos los días en la ducha para que tu Zona V siempre esté suave e hidratada{" "}
                  <b className="f-aprende-learn__text--bold">
                    gracias a su fórmula con agua de rosas
                  </b>
                </p>
              </div>
            </div>
          </div>
          <div className="f-aprende-learn__first-image desktop"></div>
        </div>
        <div className="f-aprende-learn__footer-section f-aprende-learn__footer-section--orange-light">
          <div className="f-aprende-learn__footer-section__title f-aprende-learn__footer-section__title--orange-light"></div>
          <div className="f-aprende-learn__footer-section__footer__list margin textImage">
            <ul>
              <li className="f-aprende-learn__text">
                Con <b>Agua de Rosas</b>, que mantiene la hidratación natural de la Zona V, dejándola suave e hidratada.
              </li>
              <li className="f-aprende-learn__text">
                <b>No irritante</b>, con aroma suave, libre de alcohol adicionado y de ingredientes agresivos que puedan causar irritación.
              </li>
              <li className="f-aprende-learn__text">
                Con Ácido Láctico, ingrediente natural que no altera el pH de tu zona íntima, protegiéndola contra los factores que causan irritación y posibles olores.
              </li>
              <li className="f-aprende-learn__text">
                Fórmula suave y delicada con <b>Agua Pura.</b>
              </li>
              <li className="f-aprende-learn__text">
                <b>Hipoalergénico y</b> ginecológicamente testeado.
              </li>
              <li className="f-aprende-learn__text">
                Con <b>Control de Olor</b>, ayuda a controlar olores en tu Zona V.
              </li>
            </ul>
            <img className="f-aprende-learn__footer-section__imageLibreta" src={ImageLibreta} alt="imageLibreta" />
          </div>
        </div>
        {/* <div className="f-aprende-learn__title-container">
          <div className="f-aprende-learn__title-ambassador">
            <div className="f-aprende-learn__title blue">¿Quieres ser</div>
            <p className="f-aprende-learn__text--bold-decorator pink">
              una Embajadora
            </p>
          </div>
          <div className="f-aprende-learn__text-title">
            <p>
              de <b>Jabones Íntimos Nosotras?</b>
            </p>
          </div>
        </div> */}
        {/* <div className="f-aprende-learn__btn-container middle-section">
          <BtnGeneric title={"Inscríbete"} onClick={handleToInscription} />
        </div> */}

        <div className="f-aprende-learn__first-section">
          <div className="f-aprende-learn__first-section--ancla" id="jabon-sensiti-v" />
          <div className="f-aprende-learn__first-section--left">
            <div className="f-aprende-learn__main-title"></div>
            <div className="f-aprende-learn__main-image mobile decorator"></div>
            <div className="f-aprende-learn__list-container margin decorator-desktop">
              <div className="f-aprende-learn__text ">
                <p>
                  <b className="f-aprende-learn__text--bold">
                    Usa Jabón Íntimo Nosotras Sensiti-V
                  </b>{" "}
                  todos los días en la ducha y siente su suavidad
                  y rico aroma gracias a su extracto de algodón.
                  {" "}
                  <b className="f-aprende-learn__text--bold">
                    ¡Siéntete protegida, libre de olores y molestias!
                  </b>
                </p>
              </div>
            </div>
          </div>
          <div className="f-aprende-learn__main-image desktop"></div>
        </div>
        <div className="f-aprende-learn__footer-section f-aprende-learn__footer-section--pink-light">
          <div className="f-aprende-learn__footer-section__title f-aprende-learn__footer-section__title--pink-light"></div>
          <div className="f-aprende-learn__footer-section__footer__list margin textImage">
            <ul>
              <li className="f-aprende-learn__text">
                Con <b>Extracto de Algodón</b>, ingrediente natural, suave y delicado con tu piel.
              </li>
              <li className="f-aprende-learn__text">
                Con <b>Ácido Láctico</b>, ingrediente natural que
                <b>no altera el pH de tu zona íntima,</b> protegiéndola
                contra los factores que causan irritación y posibles olores.
              </li>
              <li className="f-aprende-learn__text">
                Fórmula suave y delicada con <b>Agua Pura.</b>
              </li>
              <li className="f-aprende-learn__text">
                <b>Ginecológicamente</b> testeado.
                <b>Dermatológicamente</b> comprobado.
                <b>Hipoalergénico.</b>
              </li>
              <li className="f-aprende-learn__text">
                Con <b>Control de Olor</b>, ayuda a controlar olores en tu Zona V.
              </li>
            </ul>
            <img className="f-aprende-learn__footer-section__imageLibreta" src={ImageLibreta} alt="imageLibreta" />
          </div>
        </div>
        {/* <div className="f-aprende-learn__title-container">
          <div className="f-aprende-learn__title-ambassador">
            <div className="f-aprende-learn__title blue">¿Quieres ser</div>
            <p className="f-aprende-learn__text--bold-decorator pink">
              una Embajadora
            </p>
          </div>
          <div className="f-aprende-learn__text-title">
            <p>
              de <b>Jabones Íntimos Nosotras?</b>
            </p>
          </div>
        </div> */}
        {/* <div className="f-aprende-learn__btn-container middle-section">
          <BtnGeneric title={"Inscríbete"} onClick={handleToInscription} />
        </div> */}

        <div className="f-aprende-learn__first-section">
          <div className="f-aprende-learn__first-section--ancla" id="jabon-formula-herbal" />
          <div className="f-aprende-learn__first-section--left">
            <div className="f-aprende-learn__second-title"></div>
            <div className="f-aprende-learn__second-image mobile"></div>
            <div className="f-aprende-learn__list-container margin desktop">
              <div className="f-aprende-learn__text">
                <p>
                  Usa{" "}
                  <b className="f-aprende-learn__text--bold">
                    Jabón Íntimo Nosotras Fórmula Herbal
                  </b>{" "}
                  todos los días en la ducha,{" "}
                  <b className="f-aprende-learn__text--bold">
                    con Camelia y Aloe Vera, ingredientes naturales que protegen tu Zona V
                  </b>{" "}
                  de posibles olores. ¡Siéntete protegida, libre de olores y molestias!
                </p>
              </div>
            </div>
          </div>
          <div className="f-aprende-learn__second-image desktop"></div>
        </div>
        <div className="f-aprende-learn__footer-section f-aprende-learn__footer-section--green-light ">
          <div className="f-aprende-learn__footer-section__title f-aprende-learn__footer-section__title--green"></div>
          <div className="f-aprende-learn__footer-section__footer__list margin">
            <ul>
              <li className="f-aprende-learn__text">
                Con Camelia, ingrediente natural con
                propiedades antibacteriales que ayudan a evitar molestias.
              </li>
              <li className="f-aprende-learn__text">
                Con extracto de Aloe Vera, tiene propiedades
                humectantes, suavizantes e hidratantes.
              </li>
              <li className="f-aprende-learn__text">
                Con Ácido Láctico, ingrediente natural que no altera
                el pH de tu zona íntima, protegiéndola contra los factores
                que causan irritación y posibles olores. Ginecológicamente Testeado.
              </li>
              <li className="f-aprende-learn__text">
                Dermatológicamente Comprobado. Hipoalergénico.
              </li>
              <li className="f-aprende-learn__text">
                Con Control de Olor, ayuda a controlar olores en tu Zona V.
              </li>
            </ul>
          </div>
        </div>
        {/* <div className="f-aprende-learn__title-container">
          <div className="f-aprende-learn__title-ambassador">
            <div className="f-aprende-learn__title">¿Quieres ser</div>
            <p className="f-aprende-learn__text--bold-decorator pink">
              una Embajadora
            </p>
          </div>
          <div className="f-aprende-learn__text-title">
            <p>
              de <b>Jabones Íntimos Nosotras?</b>
            </p>
          </div>
        </div>
        <div className="f-aprende-learn__btn-container middle-section">
          <BtnGeneric title={"Inscríbete"} onClick={handleToInscription} />
        </div> */}

        <div className="f-aprende-learn__first-section">
          <div className="f-aprende-learn__first-section--ancla" id="jabon-frescura-extrema" />
          <div className="f-aprende-learn__first-section--left">
            <div className="f-aprende-learn__third-title"></div>
            <div className="f-aprende-learn__third-image mobile"></div>
            <div className="f-aprende-learn__list-container margin desktop">
              <div className="f-aprende-learn__text">
                <p>
                  Usa{" "}
                  <b className="f-aprende-learn__text--bold">
                    Jabón Íntimo Nosotras Frescura Extrema
                  </b>{" "}
                  todos los días en la ducha,
                  <b className="f-aprende-learn__text--bold">
                    con Hierbabuena y Tecnología Sensacool para que te sientas siempre fresca.
                  </b>{" "}
                  ¡Siéntete protegida, libre de olores y molestias!
                </p>
              </div>
            </div>
          </div>
          <div className="f-aprende-learn__third-image desktop"></div>
        </div>
        <div className="f-aprende-learn__footer-section f-aprende-learn__footer-section--blue-light">
          <div className="f-aprende-learn__footer-section__title f-aprende-learn__footer-section__title--blue-light"></div>
          <div className="f-aprende-learn__footer-section__footer__list margin">
            <ul>
              <li className="f-aprende-learn__text">
                Con {" "}
                <b className="f-aprende-learn__text--bold">Tecnología Sensacool</b> {" "}
                y {" "}
                <b className="f-aprende-learn__text--bold">Hierbabuena</b> {" "}
                para una máxima sensación de frescura en tu Zona V.
              </li>
              <li className="f-aprende-learn__text">
                Con {" "}
                <b className="f-aprende-learn__text--bold">Ácido Láctico</b>,{" "}
                ingrediente natural que {" "}
                <b className="f-aprende-learn__text--bold">no altera el pH de tu zona íntima,</b>{" "}
                protegiéndola contra los factores que causan irritación y posibles olores.
              </li>
              <li className="f-aprende-learn__text">
                <b className="f-aprende-learn__text--bold">Ginecológicamente</b>{" "}
                testeado. {" "}
                <b className="f-aprende-learn__text--bold">Dermatológicamente</b>
                comprobado.{" "}
                <b className="f-aprende-learn__text--bold">Hipoalergénico.</b>
              </li>
              <li className="f-aprende-learn__text">
                Con {" "}
                <b className="f-aprende-learn__text--bold">Control de Olor</b>, {" "}
                ayuda a controlar olores en tu Zona V.
              </li>
            </ul>
          </div>
        </div>
        {/* <div className="f-aprende-learn__title-container">
          <div className="f-aprende-learn__title-ambassador">
            <div className="f-aprende-learn__title">¿Quieres ser</div>
            <p className="f-aprende-learn__text--bold-decorator pink">
              una Embajadora
            </p>
          </div>
          <div className="f-aprende-learn__text-title">
            <p>
              de <b>Jabones Íntimos Nosotras?</b>
            </p>
          </div>
        </div>
        <div className="f-aprende-learn__btn-container middle-section">
          <BtnGeneric title={"Inscríbete"} onClick={handleToInscription} />
        </div> */}

      </div>
    </div>
  )
}
